<template>
 <v-container>
    <v-layout row wrap  v-for="offerte in offertes" :key="offerte.id" class="mb-2">
      <v-flex xs12>
        <v-card class="info">
          <v-container fluid>
            <v-layout >
              
              <v-flex>
                <v-card-title primary-title>
                  <div>
                    <h4 class="white--text mb-0">{{offerte.customerName}}</h4>
                    <div>{{offerte.date}}</div>
                    <h5>Totale Prijs : {{offerte.totalPrice}} &euro;</h5>
                  </div>
                </v-card-title>
                <h5>Vermogen : {{offerte.power}} KWH</h5>
                <p> {{offerte.description}}</p>
                <v-card-actions>
                  <v-btn flat :to="'/offerte/' + offerte.id">
                    <v-icon left light>arrow_forward</v-icon>
                    Details
                  </v-btn>
                   <img :src="offerte.picture" height="100">
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  export default {
    computed: {
      offertes () {
        return this.$store.getters.loadedOffertes
      }
    }
  }
</script>